import { Pill } from '@/design-system';
import { ProvenanceChip } from '@/versions/v1/shared/ProvenanceChip';
import type { MineNudgeRowModel } from './MineNudgeRow.transform';

function MineNudgeRow({ row }: { row: MineNudgeRowModel }) {
  return (
    <div
      data-mine-nudge-row
      title={row.instructionTooltip}
      className="space-y-0.5 border-t border-[var(--hairline)] pt-1.5 first:border-t-0 first:pt-0"
    >
      <div className="flex min-w-0 items-start gap-x-2">
        <Pill tone="default" className="mt-0.5 shrink-0 px-1.5 py-0 text-[10px] normal-case tracking-normal">
          {row.kindLabel}
        </Pill>
        <span className="min-w-0 flex-1 text-sm leading-snug text-zinc-900 dark:text-zinc-100">
          {row.headline}
        </span>
      </div>
      <p className="text-xs leading-snug text-muted">basis: {row.basis}</p>
      <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-0.5">
        <Pill tone="default" className="shrink-0 px-1.5 py-0 text-[10px] normal-case tracking-normal">
          {row.dispatchChip}
        </Pill>
        <ProvenanceChip text={row.provenanceChip} title={row.provenanceTooltip} compact />
      </div>
    </div>
  );
}

export function MineNudgeRows({ rows }: { rows: readonly MineNudgeRowModel[] }) {
  if (rows.length === 0) return null;
  return (
    <div className="space-y-1">
      <p className="text-xs font-medium uppercase tracking-wide text-muted">Mine-side nudge</p>
      {rows.map((row) => (
        <MineNudgeRow key={row.id} row={row} />
      ))}
    </div>
  );
}
